// Lo abonado de una reserva para el voucher (16/10/2026): lo pagado al vender (payment_methods sin la
// "Deuda", que es justamente lo que falta pagar) más los pagos registrados después (payment_reservations).

type Medio = { name?: string, value?: number | string }

export function abonadoAlVender(medios?: Medio[] | string | null): number {
    let lista: Medio[] = []
    if (typeof medios === 'string') {
        try { lista = JSON.parse(medios) || [] } catch { lista = [] }
    } else if (Array.isArray(medios)) lista = medios
    return lista
        .filter(m => m && m.name !== 'Deuda')
        .reduce((s, m) => s + (Number(m.value) || 0), 0)
}

export function abonadoDespues(pagos?: { amount?: number | string, amount_tickets?: number | string }[] | null): number {
    return (pagos || []).reduce((s, p) => s + (Number(p.amount) || 0) + (Number(p.amount_tickets) || 0), 0)
}
